// src/pages/shop-settings-tabs/InventoryTab.jsx
import React from 'react';

const InventoryTab = ({ settings, toggleField }) => (
  <div className="max-w-2xl space-y-6">
    {/* 不限库存：全局开关，影响所有H5线上下单是否校验/扣减总店库存，
        用警示色突出，避免店家没意识到这是个影响面很大的开关就随手点了 */}
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-gray-800 flex items-center gap-2">
            <span>⚠️</span>
            不限库存模式
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            开启后，H5线上下单不再检查、也不会扣减总店的库存数量，客户随时可以下单。
            关闭时会恢复正常的库存校验——但开启期间实际卖出的数量不会体现在库存数字上，
            关闭前建议先手动盘点核对一次库存。
          </p>
        </div>
        <button
          onClick={() => toggleField('stock_unlimited')}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors ml-4 ${
            settings.stock_unlimited ? 'bg-amber-500' : 'bg-gray-300'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              settings.stock_unlimited ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>

    {/* 分店间调拨审批：只影响"双方都不是总店"的调拨——总店参与的调拨总店本来就知情，
        不受这个开关影响。开启后，分店之间只能走"申请调货"这条需要总店审批的路径，
        "主动配发"这个即时发货功能对分店对分店的场景会直接不可用 */}
    <div className="bg-white rounded-xl shadow p-5">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-gray-800">分店间调拨需总店审批</h3>
          <p className="text-sm text-gray-600 mt-1">
            开启后，分店与分店之间的调拨（不涉及总店的那种）必须经总店审批通过才能进行；
            分店之间的"主动配发"即时发货功能会暂时不可用，只能走"申请调货"这条走审批的路径。
            总店参与的调拨不受此设置影响。
          </p>
        </div>
        <button
          onClick={() => toggleField('branch_transfer_requires_approval')}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors ml-4 ${
            settings.branch_transfer_requires_approval ? 'bg-blue-600' : 'bg-gray-300'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              settings.branch_transfer_requires_approval ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>
  </div>
);

export default InventoryTab;